import { store } from './index'
import { defineStore } from 'pinia'

import { useCache } from '@/hooks/useCache'
import { FormRules } from 'element-plus';

interface AppState {
    ContractRules: FormRules
}

const { wsCache } = useCache()
const ctFormRules = {
    no: [{ required: true, message: '合同编号不能为空', trigger: 'blur' }],
    name: [{ required: true, message: '合同名称不能为空', trigger: 'blur' }],
    category_id: [{ required: true, message: '类别不能为空', trigger: 'blur' }],
    mainstay_id: [{ required: true, message: '我方主体未选择', trigger: 'blur' },],
    begin_day: [{ required: true, message: '请选择合同开始日期', trigger: 'blur' },],
    end_day: [{ required: true, message: '请选择合同结束日期', trigger: 'blur' },],
    emp_used_list: [{ required: true, message: '使用人员不能为空', trigger: 'change' },],
    emp_sign_list: [{ required: true, message: '会签人员不能为空', trigger: 'change' },],
    emp_audit_list: [{ required: true, message: '部门审核人员不能为空', trigger: 'change' },],
    phone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' },],
    remark: [{ required: true, message: '合同摘要不能为空', trigger: 'blur' },],
    contract_limit: [{ required: true, message: '请选择合同工期限类型', trigger: 'blur' },],
    contract_source: [{ required: true, message: '请选择合同工订立来源', trigger: 'blur' },],
    counterpart_name: [{ required: true, message: '请选择相对方', trigger: 'blur' },],
    amount_flag: [{ required: true, message: '请选择金额类型', trigger: 'blur' },]
}

export const userFormRule = defineStore('formrules', {
    state: (): AppState => {
        return {
            ContractRules: ctFormRules
        }
    },
    getters: {
        getContractRules(): FormRules {
            return this.ContractRules
        },
    },
    actions: {
        setLoginInfo(rules: FormRules) {
            this.ContractRules = Object.assign(this.ContractRules, rules)
        }
    },
})

export const useAppStoreWithOut = () => {
    return userFormRule(store)
}